/* eslint-disable no-console,no-restricted-syntax */
import * as _ from 'lodash';

class ValidationGroup {
  constructor() {
    this.state = {
      valid: null,
      validStates: new Map(),
      errorMessages: [],
      validFields: new Map(),
    };

    this.validChangeInGroup = this.validChangeInGroup.bind(this);
    this.addValidatorToGroup = this.addValidatorToGroup.bind(this);
    this.checkValidation = this.checkValidation.bind(this);
    this.addErrorMessage = this.addErrorMessage.bind(this);
    this.clearErrorMessages = this.clearErrorMessages.bind(this);
    this.getErrors = this.getErrors.bind(this);
    this.removeValidatorToGroup = this.removeValidatorToGroup.bind(this);
  }

  clearErrorMessages(field) {
    this.state.errorMessages = this.state.errorMessages.filter((err) => err.field !== field);
  }

  addErrorMessage({ field, message, validator }) {
    this.state.errorMessages = [...this.state.errorMessages, { field, message, validator }];
  }

  validChangeInGroup(value, id) {
    this.state.validStates.set(id, value);
    this.checkValidation();
  }

  addValidatorToGroup(id) {
    const validator = this.state.validStates.get(id);
    if (validator) {
      // validator already added to the group
      return;
    }
    this.state.validStates.set(id, '');
  }

  removeValidatorToGroup(id) {
    this.state.validStates.delete(id);
  }

  clearValidatorInGroup() {
    this.state.validStates.clear();
  }

  checkValidation() {
    let validState = true;

    for (const isValid of this.state.validStates.values()) {
      if (!isValid) {
        validState = false;
        break;
      }
    }

    return validState;
  }

  getErrors() {
    const errorMessages = _.uniqBy(this.state.errorMessages, 'message');
    return errorMessages;
  }

  addField(field) {
    const fieldValue = this.state.validFields.get(field);
    if (fieldValue) {
      return;
    }
    this.state.validFields.set(field, false);
  }

  validFieldChange(field, value) {
    this.state.validFields.set(field, value);
  }

  removeField(field) {
    this.state.validFields.delete(field);
  }

  checkError(field) {
    console.log(this.state.validFields.get(field));
    return this.state.validFields.get(field);
  }
}

export default ValidationGroup;



// WEBPACK FOOTER //
// ./app/components/Validation/ValidationGroup.js